<template>
  <div class="container">
    <div class="queryFrom">
        <a-row type="flex" style="width: 100%;">
          <a-col :sm="24" :md="24" :lg="21" :xl="21">
            <!-- 关键词搜索 -->
            <div class="search-keyword">
              <a-input placeholder="邀请码、社会统一信用代码、名称" v-model="blurry" style="margin: 0 0 0 20px; width: 300px;" allowClear @pressEnter="blurrySearch"></a-input>
              <a-select v-model="advancedForm.enable" placeholder="请选择订单类型" style="width: 150px; margin: 0 10px" @change="blurrySearch" allowClear>
                <a-select-option value="1">认证</a-select-option>
                <a-select-option value="0">未认证</a-select-option>
              </a-select>
              <!-- 最后活跃时间 -->
              <a-range-picker @change="activeTime" style="width: 200px"/>
              <!-- 客户性质 -->
              <a-select v-model="advancedForm.state" placeholder="请选择客户性质" style="width: 150px; margin: 0 10px" @change="blurrySearch" allowClear >
                <a-select-option value="1">试用</a-select-option>
                <a-select-option value="0">长期</a-select-option>
                <a-select-option value="2">停用</a-select-option>
                <a-select-option value="3">试用结束</a-select-option>
              </a-select>
              <a-select v-model="advancedForm.roles" placeholder="请选择客户角色" style="width: 150px; margin: 0 10px" @change="blurrySearch" allowClear >
                <a-select-option value="1">企业</a-select-option>
                <a-select-option value="2">咨询机构</a-select-option>
                <a-select-option value="3">实验室</a-select-option>
                <a-select-option value="4">企测互通企业</a-select-option>
              </a-select>
              <a-select v-model="advancedForm.isMonitoring" placeholder="请选择监控状态" style="width: 150px; margin: 0 10px" @change="blurrySearch" allowClear>
                <a-select-option value="true">开启</a-select-option>
                <a-select-option value="false">关闭</a-select-option>
              </a-select>
              <a-button type="primary" icon="search" @click="blurrySearch">搜索</a-button>
            </div>
          </a-col>

          <a-col :sm="24" :md="24" :lg="3" :xl="3">
            <a-button type="primary" style="float:right;margin: 8px 20px 8px 0;" icon="plus" @click="adduser">添加客户</a-button>
          </a-col>
        </a-row>
    </div>
    <div class="table">
      <a-table
        :columns="columns"
        :dataSource="tableData"
        :pagination="pagination"
        @change="pagChange"
        :rowKey="record => record.id"
        :loading="loading"
        :scroll="{ y: 600 }"
        style="background:#fff;"
      >
      <template slot="info" slot-scope="record">
        <p v-if="record.type =='1'">
          <router-link :to="{ 
            path: '/user/admin/agencyManage',
            name:'agency-manage', 
            query:{id:record.deptId}}"
          >{{record.name}}</router-link>
        </p>
        <p v-else>{{record.name}}</p>
        <p>
          <span >{{record.orgcode}} </span>
          <a-tag v-if="record.type =='0'" style="color:red">企业</a-tag>
          <a-tag v-if="record.type =='1'" style="color:#1890ff">咨询机构</a-tag>
          <a-tag v-if="record.type =='3'" style="color:#e97a13">实验室</a-tag>
          <a-tag v-if="record.type =='4'" style="color:#5cd580">企测互通企业</a-tag>
        </p>
      </template>
      <!-- 联系人：主账号手机号和用户个数，点击用户个数可显示其手机号、姓名和注册时间 -->
      <template slot="userPhones" slot-scope="record">
        <span>
          {{record.dto.phone}}/ <i style="cursor: pointer; color:#1890ff" @click="showContactPerson(record)">{{record.dto.num}}</i>
        </span>
      </template>
      <template slot="enabled" slot-scope="record">
        <p>{{record.enabled?'已认证':'未认证'}}</p>
      </template>
      <template slot="state" slot-scope="record">
        <P>{{record.state?'正常':'禁用'}}</P>
      </template>
      
      <template slot="deptNum" slot-scope="record">
        <span v-if="record.deptNum<=0">-</span>
        <span v-else>{{record.deptNum}}</span>
      </template>

      <template slot="certNum" slot-scope="record">
        <span v-if="record.certNum<=0">-</span>
        <span v-else>{{record.certNum}}</span>
      </template>
      <template slot="state" slot-scope="record">
        <span v-if="record.state == 0">长期</span>
        <span class="green" v-if="record.state == 1">试用</span>
        <span class="red" v-if="record.state == 2">停用</span>
        <span class="red" v-if="record.state == 3">试用结束</span>
      </template>
      
      <template slot="reportNum" slot-scope="record">
        <span v-if="record.reportNum<=0">-</span>
        <span v-else>{{record.reportNum}}</span>
      </template>
      <!-- 订单数 -->
      <template slot="orderNum" slot-scope="record">
        <span v-if="record.orderNum<=0">-</span>
        <span v-else>{{record.orderNum}}</span>
      </template>
      <template slot="keyNum" slot-scope="record">
        <span v-if="record.keyNum<=0">-</span>
        <span v-else>{{record.keyNum}}</span>
      </template>
      <template slot="activeTime" slot-scope="activeTime">
        <span>{{activeTime | formatDateTime}}</span>
      </template>
      <template slot="tryTimes" slot-scope="record">
        <span v-if="record.tryStartTime">{{record.tryStartTime | formatDate}}</span>
        <span v-if="record.tryStartTime">~</span>
        <span v-if="record.tryEndTime">{{record.tryEndTime | formatDate}}</span>
        <span v-if="!record.tryStartTime">-</span>
      </template>
      <template slot="isMonitoring" slot-scope="record">
        <span><a-switch v-model="record.isMonitoring" disabled/></span>
      </template>
      <template slot="operation" slot-scope="record">
        <!-- <a-button type="link" @click="stateShowConfirm(record.deptId,record.state)" style="padding:0;">{{record.state?'禁用':'启用'}}</a-button> -->
        <a-button type="link" @click="edituser(record)" style="padding:0;">编辑</a-button>
        <a-divider type="vertical" />
        <a-button v-if="!record.userDeptId" type="link" style="padding:0;" disabled>删除</a-button>
        <a-button v-else type="link" @click="itemDel(record.userDeptId,record.state)" style="padding:0;">删除</a-button>
        
        <!-- <a-button v-if="record.type =='0'" type="link" @click="agencyShowConfirm(record.deptId,record.type,record.name)" style="padding:0;">成为中介</a-button>
        <a-button v-if="record.type =='1'" type="link" @click="agencyShowConfirm(record.deptId,record.type,record.name)" style="padding:0;">取消中介</a-button> -->
      </template>
    </a-table>
    </div>

    <a-modal v-if="userVisible" :visible="true" :footer="null" title="添加客户" @cancel="closeUserVisible" :maskClosable='false'>
      <a-form :form="forms">
        <a-form-item v-bind="formItemLayout" label="客户企业名称" >
          <a-input placeholder="请输入客户企业名称" 
            v-decorator='["name",
              {rules: [{ required: true, message: "请输入客户企业名称" }]}
            ]'
            :maxLength="150"
          />
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="统一社会信用代码" >
          <a-input :maxLength="18" placeholder="请输入统一社会信用代码" 
            v-decorator="['orgcode', {rules: [{required: true, message: '请输入统一社会信用代码'}]}]"
          />
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="角色" >
          <a-select style="width:140px"
          @change="rolesChange"
          v-decorator='["roles",{
            rules: [{ required: true, message: "请选择角色" }],
             initialValue:formInitialValue.roles,
            },
          ]'>
            <a-select-option value="0">企业</a-select-option>
            <a-select-option value="1">咨询机构</a-select-option>
            <a-select-option value="3">实验室</a-select-option>
            <a-select-option value="4">企测互通企业</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="所在区域" >
          <a-cascader 
              :options="cityData" 
              placeholder="请选择城市" 
              @change="selectCity" 
              v-decorator="[
                'region',
                { rules: [{ required: true, message: '请选择所在地' }],initialValue: formInitialValue.region},
              ]"
            />
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="客户性质" >
          <a-radio-group
          @change="radioChange"
          v-decorator='["state",{
            rules: [{ required: true, message: "请选择客户性质" }],
             initialValue:formInitialValue.state,
            },
          ]'>
            <a-radio value="1">试用</a-radio>
            <a-radio value="0">长期</a-radio>
            <a-radio value="2">停用</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item v-if="testTime" v-bind="formItemLayout" label="试用时长" >
          <a-range-picker :disabled-date="disabledEndDate" v-decorator="['tryTimes', {
            rules: [{required: true, message: '请输入试用时长'}], initialValue:formInitialValue.times,
          }]"/>
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="功能授权" v-if="needConsistencyIsShow" >
          <a-checkbox v-decorator="['needConsistency', {
            valuePropName: 'checked',
            rules: [{required: false, message: '请勾选功能授权'}]
          }]">一致性管控</a-checkbox>
        </a-form-item>
        <a-form-item >
          <a-button type="primary" style="float:right" @click="submitUser">提交</a-button>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal :visible="userVisible2" :footer="null" title="编辑客户" @cancel="closeUserVisible" :maskClosable='false'>
      <a-spin :spinning="spinning">
      <a-form :form="form">
        <a-form-item v-bind="formItemLayout" label="客户企业名称" colon >
          <a-input :disabled="ifEdit" placeholder="请输入客户企业名称" 
            v-decorator='["name",
              {rules: [{ required: true, message: "请输入客户企业名称" }]}
            ]'
          />
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="统一社会信用代码" colon >
          <a-input :disabled="ifEdit" :maxLength="18" placeholder="请输入统一社会信用代码" 
            v-decorator="['orgcode', {rules: [{required: true, message: '请输入统一社会信用代码'}]}]"
          />
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="角色" colon >
          <a-select style="width:140px"
          @change="rolesChange"
          v-decorator='["type",{
            rules: [{ required: true, message: "请选择角色" }],
            },
          ]'>
            <a-select-option value="0">企业</a-select-option>
            <a-select-option value="1">咨询机构</a-select-option>
            <a-select-option value="3">实验室</a-select-option>
            <a-select-option value="4">企测互通企业</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="所在区域" colon >
          <a-cascader 
              :options="cityData" 
              placeholder="请选择城市" 
              v-decorator="[
                'region',
                { rules: [{ required: true, message: '请选择所在地' }]},
              ]"
            />
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="客户性质" colon >
          <a-radio-group
          @change="radioChange"
          v-decorator='["state",{
            rules: [{ required: true, message: "请选择客户性质" }]},
          ]'>
            <a-radio value="1">试用</a-radio>
            <a-radio value="0">长期</a-radio>
            <a-radio value="2">停用</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item v-if="testTime" v-bind="formItemLayout" label="试用时长" colon >
          <a-range-picker :disabled-date="disabledEndDate" v-decorator="['tryTimes', {
            rules: [{required: true, message: '请输入试用时长'}]
          }]"/>
        </a-form-item>
        <!-- v-if="needConsistencyIsShow" -->
        <a-form-item v-bind="formItemLayout" label="功能授权" v-if="needConsistencyIsShow"  colon >
          <a-checkbox
           v-decorator="['needConsistency', {
            valuePropName: 'checked',
            rules: [{required: false, message: '请勾选功能授权'}]
          }]">一致性管控</a-checkbox>
        </a-form-item>
        <a-form-item >
          <a-button type="primary" style="float:right" @click="submiteditUser">提交</a-button>
        </a-form-item>
      </a-form>
     </a-spin>
    </a-modal>
    <a-modal title="更多联系人" :visible="userVisible3" :footer="null" @cancel="hideContactPerson" >
      <a-row style="margin-bottom: 10px;">
        <a-col :span="6">手机号</a-col>
        <a-col :span="6">姓名</a-col>
        <a-col :span="6">注册时间</a-col>
        <a-col :span="6">最近活跃时间</a-col>
      </a-row>
      <a-row v-for="(item,index) in contactPersons" :key="index" style="margin-bottom: 10px;">
        <a-col :span="6">{{item.phone}}</a-col>
        <a-col :span="6">
          <span v-if="item.realname">{{item.realname}}</span>
          <span v-else>-</span>
        </a-col>
        <a-col :span="6">
          <span v-if="item.createTimeStr">{{item.createTimeStr}}</span>
          <span v-else>-</span>
        </a-col>
        <a-col :span="6">
          <span v-if="item.activeTimeStr">{{item.activeTimeStr}}</span>
          <span v-else>-</span>
        </a-col>
      </a-row>
    </a-modal>

  </div>

</template>


<script>
import {checkSocialCode} from '@/utils'
import {formatDate, dateDiff} from '../../../utils/date';
import moment from 'moment';
 import {
   deptManage, //基本列表
   adminDisable, //启用状态
   adminMediation,  //中介状态
   allRoles,
  //  addUser,  
   addClient,//添加客户
   editInvite, //编辑客户
   deleteUserDept,  //删除

   } from "@/api/user"
const align= 'center'
const columns = [
  {
    title: "企业信息",
    scopedSlots: { customRender: 'info' },
    align
  },
  {
    title: "邀请码",
    dataIndex: "invitationCode",
    scopedSlots: { customRender: 'invitationCode' },
    align,
    sorter: true
  },
  {
    title: "联系人",
    scopedSlots: { customRender: 'userPhones' },
    // dataIndex: "userPhones",
    align,
    width: 130
  },
  {
    title: "实名状态",
    scopedSlots: { customRender: 'enabled' },
    align
  },
  {
    title: "客户性质",
    scopedSlots: { customRender: 'state' },
    align
  },
  {
    title: "企业数量",
    scopedSlots: { customRender: 'deptNum' },
    align
  },
  {
    title: "证书数量(份)",
    scopedSlots: { customRender: 'certNum' },
    align
  },
  {
    title: "关键件数量(份)",
    scopedSlots: { customRender: 'keyNum' },
    align
  },
  {
    title: "报告数量(份)",
    scopedSlots: { customRender: 'reportNum' },
    align
  },
  {
    title: "订单数量(份)",
    scopedSlots: { customRender: 'orderNum' },
    align
  },
  {
    title: "最近活跃时间",
    dataIndex: 'activeTime',
    scopedSlots: { customRender: 'activeTime' },
    align,
    sorter: true
  },
  {
    title: "试用时段",
    scopedSlots: { customRender: 'tryTimes' },
    align,
  },
  {
    title: "证书监控",
    scopedSlots: { customRender: 'isMonitoring' },
    align,
  },
  {
    title: '操作',
    scopedSlots: { customRender: 'operation' },
    align,
    width:120
  }
];

export default {
  data() {
    return {
      contactPersons: [],
      cityData: this.$province, // 城市
      id:"",
      searchVisible:false,
      loading:false,
      columns,
      tableData:[],
      userVisible:false,
      userVisible2:false,
      userVisible3:false,
      // editdata:{
      //   id:"",
      //   name:"",
      //   orgcode:"",
      //   type:"",
      // },
      blurry:'',
      searcVisible:false,
      advancedForm:{
        state: undefined,
        roles: undefined,
        enable: undefined,
        startActiveTime: '',
        endActiveTime: '',
        isMonitoring: undefined,
      },
      formInitialValue:{
        roles:'4',
        state: '1',
        times: [],
        region: [],
      },
      form:this.$form.createForm(this),
      forms:this.$form.createForm(this),
      highForm:this.$form.createForm(this),
      formItemLayout:{
        labelCol: {
            span: 7
        },
        wrapperCol: {
            span: 17
        },
      },
      highFormItemLayout:{
        labelCol: {
            span: 7
        },
        wrapperCol: {
            span: 17
        },
      },
      pagination:{
        showSizeChanger:true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条记录`,
        showSizeChange:(current, pageSize) => {
          this.pageSize = pageSize
        }
      },
      sortType: '',
      sortBy: '',
      allRoles:[],
      isFilter: false,
      ifEdit: false,
      testTime: false,
      spinning: false,
      startValue: null,
      needConsistencyIsShow: true,
    }
  },
  mounted() {
    if(this.$route.query.userDeptId){
      this.userDeptId = this.$route.query.userDeptId
    }else{
      this.userDeptId = ''
    }
    this.getTableData();
    var beginTime = Date.parse(new Date());
    this.startValue = Date.parse(new Date(beginTime - 1000 * 60 * 60 * 24 * 1))
    var afterTime = Date.parse(new Date(beginTime + 1000 * 60 * 60 * 24 * 30));
    this.formInitialValue.times = [moment(beginTime), moment(afterTime)];
    // this.getAllRoles()
  },
  methods: {
    hideContactPerson() {
      this.userVisible3 = false;
    },
    showContactPerson(row) {
      this.contactPersons = row.dto.userdto;
      this.userVisible3 = true;
    },
    rolesChange(value) {
      if(value == '3') {
        this.needConsistencyIsShow = false;
      }else {
        this.needConsistencyIsShow = true;
      }
    },
    selectCity(value){
      this.formInitialValue.region = value;
    },
    moment,
    disabledEndDate(endValue) {
      const startValue = this.startValue;
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
    check (rule, value, callback) {
      checkSocialCode(rule, value, callback)
    },
    radioChange(e) {
      let val = e.target.value;
      if (val === '1') {
        this.testTime = true;
      } else {
        this.testTime = false;
      }
    },
    /**
     * 获取角色列表
     */
    getAllRoles(){
      allRoles().then(res=> {
        this.allRoles = res
      }).catch(error=> {
        console.log(error)
      })
    },
    /**
     * 获取table基本数据
     */
    async getTableData(){
      let params = {
        page:this.pagination.current -1,
        size:this.pagination.pageSize,
        blurry:this.blurry,
        enable:this.advancedForm.enable,
        roles:this.advancedForm.roles,
        state:this.advancedForm.state,
        startActiveTime: this.advancedForm.startActiveTime,
        endActiveTime: this.advancedForm.endActiveTime,
        sortType: this.sortType,
        sortBy: this.sortBy,
        isMonitoring: this.advancedForm.isMonitoring=='false'?false:this.advancedForm.isMonitoring=='true'?true:null
      }
      this.loading = true;
      try{
        let data = await deptManage(params);
        this.tableData = data.content;
        console.log('表格数据', this.tableData);
        this.pagination.total = data.totalElements;
        this.loading = false ;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    /**
     * 模糊搜索
    */
    blurrySearch(){
      this.pagination.current = 1;
      this.getTableData();
    },
    activeTime(dates) {
      if(dates.length>0) {
        this.advancedForm.startActiveTime = Date.parse(formatDate(new Date(dates[0]._d),"yyyy/MM/dd"));
        this.advancedForm.endActiveTime = Date.parse(formatDate(new Date(dates[1]._d),"yyyy/MM/dd"))+(23*3600*1000)+(3599*1000);
      }else {
        this.advancedForm.startActiveTime = '';
        this.advancedForm.endActiveTime = '';
      }
      this.blurrySearch();
    },
    /**
     * 打开添加客户弹出框
     */
    adduser(){
      this.userVisible = true;
      this.testTime = true;
    },
    edituser(data){
      this.userVisible2 = true
      this.spinning = true;
      this.ifEdit = data.enabled;
      this.id = data.id;
      if (data.state == '1') {
        this.testTime = true;
      } else {
        this.testTime = false;
      }
      
      let params = {
        name:data.name,
        orgcode:data.orgcode,
        type:data.type,
        region: data.regionCode?data.regionCode.split(','):[],
        state: data.state,
        tryTimes: data.tryStartTime? [moment(data.tryStartTime), moment(data.tryEndTime)] : null,
      }
      if(data.type == "3") {
        this.needConsistencyIsShow = false;
      }else {
        this.needConsistencyIsShow = true;
        params.needConsistency = data.needConsistency;
      }
      this.$nextTick(() => {
        this.form.setFieldsValue(params);
        this.spinning = false;
      });
      
      // this.editdata = {
      //   id:data.id,
      //   name:data.name,
      //   orgcode:data.orgcode,
      //   type:data.type,
      // },
         
    },
    /**
     * 关闭添加客户弹出框
     */
    closeUserVisible(){
      this.userVisible = false
      this.userVisible2 = false
      this.needConsistencyIsShow = true
    },
    /**
     * 提交添加客户
     */
    submitUser(){
      this.forms.validateFields( async (err, params) => {
        if(!err){
          let tryStartTime = '';
          let tryEndTime = '';
          if(params.tryTimes){
            tryStartTime = Date.parse(formatDate(new Date(params.tryTimes[0]._d),"yyyy/MM/dd"))
            tryEndTime = Date.parse(formatDate(new Date(params.tryTimes[1]._d),"yyyy/MM/dd"))+(23*3600*1000)+(3599*1000)
          }
          let newParams = {
            orgcode:params.orgcode,
            name: params.name,
            type:params.roles,
            state: params.state,
            needConsistency: params.needConsistency,
            tryStartTime: tryStartTime,
            tryEndTime: tryEndTime,
            region: `${params.region[0]},${params.region[1]}`
          }
          this.addusers(newParams)
        }
      })
    },
    // 提交编辑客户
    submiteditUser(){
      this.form.validateFields( async (err, params) => {
        if(!err){
          let tryStartTime = '';
          let tryEndTime = '';
          if(params.tryTimes){
            tryStartTime = Date.parse(formatDate(new Date(params.tryTimes[0]._d),"yyyy/MM/dd"))
            tryEndTime = Date.parse(formatDate(new Date(params.tryTimes[1]._d),"yyyy/MM/dd"))+(23*3600*1000)+(3599*1000)
          }
          let newParams = {
            id:this.id,
            orgcode:params.orgcode,
            name: params.name,
            type:params.type,
            state: params.state,
            tryStartTime: tryStartTime,
            tryEndTime: tryEndTime,
            needConsistency: params.needConsistency,
            region: `${params.region[0]},${params.region[1]}`,
          }
          this.editusers(newParams);
        }
      })
    },
    /**
     * 添加客户
     */
    async addusers(params){
      // console.log('添加用户最红：',params)
      try{
        let data = await addClient(params);
        this.$message.success("添加成功");
        this.getTableData();
        this.userVisible = false;
      } catch(error){
        // this.$message.error(error.response.data.message)
        this.$message.success("添加失败");
        this.userVisible = false;
      }
    },
    // editInvite
    async editusers(params){
      // console.log('编辑用户最红：', params)
      try{
        let data = await editInvite(params);
        this.$message.success("编辑成功");
        // this.$store.commit('changeRoterState', true);
        this.getTableData();
        this.userVisible2 = false;
      } catch(error){
        // this.$message.error(error.response.data.message)
        this.$message.success("添加失败");
        this.userVisible2 = false;
      }
    },
    /**
     * 翻页
     */
    pagChange(pagination,filters,sorter){
      if (sorter) {
        this.sortBy = sorter.columnKey;
        if (sorter.order == "ascend") {
            this.sortType = 'ASC';
        } else {
            this.sortType = 'DESC';
        }
      } else {
        this.sortBy = '';
        this.sortType = '';
      }
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getTableData();
    },
    /**
     * 状态对话框
     */
    stateShowConfirm(deptId,state) {
      let params = {
        deptId:deptId,
        state:''
      }
      params.state = state?0:1;
      let that = this;
      that.$confirm({
        title: '你确定要更改状态吗?',
        content: `你确定要将状态更改为${state?'禁用':'正常'}吗?`,
        onOk() {
          adminDisable(params).then(res => {
            that.getTableData()
          }).catch(error=>{
            console.log("error",error)
          })
        },
        onCancel() {
        },
        class: 'test',
      });
    },

    itemDel(id,state) {
      let that = this
      that.$confirm({
        title: '你确定要删除吗?',
        onOk() {
          deleteUserDept(id).then(res => {
            let mod = (that.pagination.total - 1)%10  //余数为0页数减一
            let currentPage = Math.ceil((that.pagination.total - 1)/that.pagination.pageSize);
            if(mod == 0){ 
              if(that.pagination.current>1){
                if(that.pagination.current != currentPage){
                  that.pagination.current--
                }
              } 
            }
            that.getTableData()
          }).catch(error=>{
            console.log("error",error)
          })
        },
        onCancel() {
        },
        class: 'test',
      });
    },

    agencyShowConfirm(deptId,type,name){
      let params = {
        deptId:deptId,
        state:''
      }
      let content = ''
      if(type =='0'){
        params.state = 1
        content = `你确定要将${name}设置为中介吗？`
      }else if(type =='1'){
        params.state = 0
        content = `你确定要取消${name}的中介身份吗？`
      }else{
        params.state = ''
        content = ''
      }
      
      let that = this
      that.$confirm({
        title: '你确定要改变中介状态吗？',
        content: content,
        onOk() {
          let newParams = params
          adminMediation(newParams).then(res=>{
            that.getTableData()
          }).catch(error=>{
            console.log("error",error)
          })
        },
        onCancel() {
        },
        class: 'test',
      });
    }
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy/MM/dd");
    },
    formatDateTime(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy/MM/dd hh:mm");
    },
    spliceChinese(val) {
      if (val) {
        var reg = /[\u4e00-\u9fa5]/g;
        if (val.match(reg)) {
            return val.match(reg).join('');
          } else {
            return val;
          }
      }
    }
  },
  watch: {
     userVisible(val){
      if(val){
        this.form.resetFields()
      }
    },
  },
}
</script>
<style lang="less" scoped>
.green {
  color: #67C23A;
}
.red {
  color: #F56C6C;
}
.ant-form-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }
  .container{
    min-height: 100%;
    // background-color: #fff;
    // padding: 15px;
    .queryFrom{
      margin-bottom: 24px;
      background-color: #fff;
      overflow: hidden;
      padding: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .search-keyword {
        // max-width: 500px;
        // width: 57%;
        min-width: 400px;
        float: left;
        margin: 8px 20px  8px 0;
        display: flex;
        align-items: center;
        .ant-input {margin-right: 10px;}
      }
      .advanced-search{
        margin: 8px 20px  8px 0;
        .form-container{
          width: 600px;
        }
      }
    }
    .btnTag{
      height:32px;
      line-height: 32px;
      font-size: 14px;
      border-radius: 4px;
      margin-right:5px;
      p{
        line-height: 32px;
      }
    }
  }
</style>